import { getResponsiveStyles } from '../../../component-themes';
export const navigationBarBrandAreaTagline = (tokens) => ({ size, onBackground, }) => getResponsiveStyles(size, (size) => ({
    color: tokens.styles[`navigation-bar-tagline-${onBackground}-${size}-color`],
    fontSize: tokens.styles[`navigation-bar-tagline-${onBackground}-${size}-fontSize`],
    fontFamily: tokens.styles[`navigation-bar-tagline-${onBackground}-${size}-fontFamily`],
    lineHeight: tokens.styles[`navigation-bar-tagline-${onBackground}-${size}-lineHeight`],
    fontWeight: tokens.styles[`navigation-bar-tagline-${onBackground}-${size}-fontWeight`],
    letterSpacing: tokens.styles[`navigation-bar-tagline-${onBackground}-${size}-letterSpacing`],
}));
